import { TenantDashboard } from 'app/library/tenant-dashboard/models/tenant-dashboard';
import { User } from 'app/projects/user/src/lib/models/user';
import { ITeamMemberQuery } from '../interfaces/team-member.query.interface';

export class TeamMember {
    avgLearningTime: number;
    totalLearningTime: number;
    user: User;
    yearlyActiveDays: number;
    charts: TenantDashboard[];
    certificateStats: { expiredCount: number; expiringCount: number; totalCount: number };

    constructor(teamMemberQuery: ITeamMemberQuery) {
        this.avgLearningTime = teamMemberQuery.avg_learning_time;
        this.totalLearningTime = teamMemberQuery.total_learning_time;
        this.user = new User(teamMemberQuery.user);
        this.yearlyActiveDays = teamMemberQuery.yearly_active_days;
        this.charts = teamMemberQuery.charts ? teamMemberQuery.charts.map((chart) => new TenantDashboard(chart)) : [];
        this.certificateStats = {
            expiredCount: teamMemberQuery.certificate_statistics?.expired_count,
            expiringCount: teamMemberQuery.certificate_statistics?.expiring_count,
            totalCount: teamMemberQuery.certificate_statistics?.total_count,
        };
    }
}
